import history from 'src/history'
import Section from '../../Section'
import { Button } from 'src/Components'
import ListingsBot from '../../ListingsBot'
import { AgentCard } from '../../AgentCard'
import PropertyStats from '../../PropertyStats'
import { defineMessages, useIntl } from 'react-intl'
import { OVERLAY_HELPERS } from 'src/constants/navigation'
import { ListingDetailsListing } from 'src/types/listings'
import { IconImageInverted } from 'src/Components/shared/Icon'

import styles from './DesktopListingDetailsSidebar.module.scss'

export const MSG = defineMessages({
  photosBtn: {
    id: 'HomeSearch.listingDetails.photos.viewAll',
    defaultMessage: 'View {num} photos',
  },
})

export interface DesktopListingDetailsSidebarProps {
  listing: ListingDetailsListing
}

export const DesktopListingDetailsSidebar = ({
  listing,
}: DesktopListingDetailsSidebarProps) => {
  const intl = useIntl()

  return (
    <div className={styles.sidebar}>
      <Button
        secondary
        fullWidth
        iconStart={IconImageInverted}
        onClick={() =>
          history.push(OVERLAY_HELPERS.listingDetailsPhotos.buildPath())
        }
      >
        {intl.formatMessage(MSG.photosBtn, {
          num: listing.thumbnailImageFileNames?.length,
        })}
      </Button>
      <Section className={styles.section}>
        <Section.Body>
          <PropertyStats listing={listing} />
          <Section.Divider />
          <ListingsBot listing={listing} />
          <Section.Divider />
        </Section.Body>
      </Section>
      <AgentCard className={styles.section} />
    </div>
  )
}
